export { B2CLayout, default } from './B2CLayout';
